import React from 'react';

import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  TableContainer,
  Link,
} from '@gogame/components';

const SectionWithIdNameTable = ({ data, onLinkOpen, renderId }) => {
  return data?.length ? (
    <TableContainer>
      <Table width={'100%'}>
        <TableHead>
          <TableRow>
            <TableCell width={'25%'}>Id</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(({ id, name }, i) => (
            <TableRow key={i}>
              <TableCell width={'25%'}>
                {renderId ? renderId({ id, name }) : id}
              </TableCell>
              <TableCell>
                <Link onClick={() => onLinkOpen({ id })}>{name}</Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Typography color={'textSecondary'}>No campaigns</Typography>
  );
};

export default SectionWithIdNameTable;
